import {
  AvatarComposite,
  type AvatarCompositeSize
} from '@/shared/ui/AvatarComposite'

export type CosmeticImageLike =
  | { image?: { file?: { url?: string } } | null }
  | null
  | undefined

function layerUrl(layer: CosmeticImageLike): string | null {
  const url = layer?.image?.file?.url
  return url && url.length > 0 ? url : null
}

export function CosmeticAvatarComposite({
  avatar,
  frame,
  background,
  size = 'xs',
  className,
  'aria-label': ariaLabel
}: {
  avatar?: CosmeticImageLike
  frame?: CosmeticImageLike
  background?: CosmeticImageLike
  size?: AvatarCompositeSize
  className?: string
  'aria-label'?: string
}) {
  return (
    <AvatarComposite
      backgroundUrl={layerUrl(background)}
      avatarUrl={layerUrl(avatar) ?? '/placeholders/avatar.png'}
      frameUrl={layerUrl(frame)}
      size={size}
      className={className}
      aria-label={ariaLabel}
    />
  )
}
